import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import DashboardHeader from '../../components/DashboardHeader';
import DashboardFooter from '../../components/DashboardFooter';
import Constants from '../../utils/constants';

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingRight: '20%',
    paddingLeft: '20%',
    paddingTop: '50px'
  },
}));

export default function ErrorLayout({children}) {
  const classes = useStyles();
  const createMenus = (path, name) => {
    return {path, name};
  };

  const menus = [
    createMenus(Constants.nullPath, 'Error 404'),
  ];

  return (
    <div id="body-container">
      <DashboardHeader menus={menus}/>
      <div className={classes.wrapper}>
        {children}
      </div>
      <DashboardFooter />
    </div>
  );
}